import styled from 'styled-components';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormWrapperWithTitle from '../../../components/UI/Wrapper/Form/FormWrapperWithTitle';
import { PaperUI } from '../../../components';

export default makeStyles({
  button: {
    backgroundColor: '#ff1381',
    color: 'white',
    width: '44px',
    height: '44px',
    '&:hover': {
      backgroundColor: '#ff1381',
      opacity: '.7',
    },
  },
});

export const ContainerPrincipal = styled(PaperUI)`
    padding: 22px;
    height: 100%;
    #resumo{
     display:flex ;
     flex-direction:column ;
     justify-content:start ;
     width:45% ;
      }
 `;

export const WrapperFormWithTitle = styled(FormWrapperWithTitle)`
 margin-bottom: 10px;
 > h3 {
    color: black;
 }
`;

export const ResumoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    display: block;
    margin-bottom: 9px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
  }

  >div {
    display: flex;
    justify-content: space-around;

    >div + div {
      margin-left: 8px;
          }
  }
`;

export const CardTop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  box-sizing: border-box;
  width: 190px;
  height: 52px;
  border-radius: 5px;

  background-color: ${props => props.color};

  p {
    display: block;
    font-family: Roboto;
    font-style: normal;
    font-size: 12px;
    line-height: 14px;

    color: #FFFFFF;
  }

  p:first-child {
    padding-top: 5px;
    margin-Top: 8px;
  }

  p:last-child {
    padding-top: 11px;
    padding-bottom: 13px;

  }
`;
